import { useEffect, useRef, useState } from 'react';
import { StyleSheet } from 'react-native';

import SplashImage from 'assets/Splash/splash-image.png';
import SplashVideo from 'assets/Splash/splash-video-1080p.mp4';

type SplashScreenProps = {
  onFinish: () => void;
};

const SplashScreen: React.FC<SplashScreenProps> = ({ onFinish }) => {
  const videoRef = useRef<HTMLVideoElement>(null);
  const [videoError, setVideoError] = useState(false);

  useEffect(() => {
    const video = videoRef.current;
    if (!video) return;

    const playPromise = video.play();

    if (playPromise !== undefined) {
      playPromise.catch(() => {
        video.muted = true;
        video.play().catch(() => {
          onFinish();
        });
      });
    }
  }, [onFinish]);

  if (videoError) {
    return (
      <img
        src={SplashImage}
        alt="Splash"
        onLoad={() => setTimeout(onFinish, 4000)}
        style={{
          position: 'fixed',
          inset: 0,
          width: '100%',
          height: '100%',
          objectFit: 'cover',
          background: 'black',
        }}
      />
    );
  }

  return (
    <video
      ref={videoRef}
      playsInline
      onEnded={onFinish}
      style={styles.splashScreen}
      onError={() => setVideoError(true)}>
      <source src={SplashVideo} type="video/mp4" />
    </video>
  );
};

export default SplashScreen;

const styles = StyleSheet.create({
  splashScreen: {
    position: 'absolute',
    top: 0,
    bottom: 0,
    right: 0,
    left: 0,
    width: '100%',
    height: '100%',
    objectFit: 'cover',
    backgroundColor: '#000',
  },
});
